module.exports = __webpack_public_path__ + "img/showcase-hero-bg.c94139dc.jpg";